'use client';

// Error boundaries must be Client Components
import { reportError } from '@lib/utils/reportError';
import { useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@src/components/ui/card';
import { Button } from '@src/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
export default function Error({
  error,
  reset
}: {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}) {
  const {
    reset: resetQueryError
  } = useQueryErrorResetBoundary();
  useEffect(() => {
    reportError(error);
  }, [error]);
  return <div className="flex min-h-[400px] items-center justify-center p-4" data-sentry-component="Error" data-sentry-source-file="error.tsx">
      <Card className="w-full max-w-md" data-sentry-element="Card" data-sentry-source-file="error.tsx">
        <CardHeader className="text-center" data-sentry-element="CardHeader" data-sentry-source-file="error.tsx">
          <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10">
            <AlertTriangle className="size-6 text-destructive" data-sentry-element="AlertTriangle" data-sentry-source-file="error.tsx" />
          </div>
          <CardTitle className="text-xl" data-sentry-element="CardTitle" data-sentry-source-file="error.tsx">Something went wrong!</CardTitle>
          <CardDescription data-sentry-element="CardDescription" data-sentry-source-file="error.tsx">
            An unexpected error occurred while loading this page. This has been reported automatically.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center" data-sentry-element="CardContent" data-sentry-source-file="error.tsx">
          <Button onClick={() => {
          resetQueryError();
          reset();
        }} className="w-full" data-sentry-element="Button" data-sentry-source-file="error.tsx">
            <RefreshCw className="mr-2 size-4" data-sentry-element="RefreshCw" data-sentry-source-file="error.tsx" />
            Try again
          </Button>
        </CardContent>
      </Card>
    </div>;
}